var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewHl7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66536H3.33333C2.598 6.66536 2 7.26336 2 7.9987V13.332C2 14.0674 2.598 14.6654 3.33333 14.6654H12.6667C13.402 14.6654 14 14.0674 14 13.332V7.9987C14 7.26336 13.402 6.66536 12.6667 6.66536ZM3.33333 13.332V7.9987H12.6667L12.668 13.332H3.33333ZM3.33333 3.9987H12.6667V5.33203H3.33333V3.9987ZM4.66667 1.33203H11.3333V2.66536H4.66667V1.33203Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHl7);
export default __webpack_public_path__ + "static/media/viewHL7.4bc616423b8a4c1a6b09a9fb40d1189d.svg";
export { ForwardRef as ReactComponent };